import axios from "axios";
import { useContext, useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AuthContext } from "../auth/AuthProvider";

import "./style/PhaseLayout.css";

export default function PhaseLayout1() {
  const [phase, setPhase] = useState({});
  const [showPhase1, setShowPhase1] = useState({
    id1: 0,
    show: false,
  });

  const [question, setQuestion] = useState([]);

  const [change, setChange] = useState(false);

  const {
    refreshTrigger,
    userQuestion1,
    userQuestion2,
    userQuestion3,
    userQuestion4,
    userQuestion5,
    setUserQuestion1,
    setUserQuestion2,
    setUserQuestion3,
    setUserQuestion4,
    setUserQuestion5,
    googleUserQuestion1,
    googleUserQuestion2,
    googleUserQuestion3,
    googleUserQuestion4,
    googleUserQuestion5,
    setGoogleUserQuestion1,
    setGoogleUserQuestion2,
    setGoogleUserQuestion3,
    setGoogleUserQuestion4,
    setGoogleUserQuestion5,
    user,
    googleUser,
    phase1Complete,
    setPhase1Complete,
    apiUrl,
  } = useContext(AuthContext);

  const { id, phaseTitle, hashed } = useParams();

  const [precentCompletion, setPrecentCompletion] = useState(0);

  const [effect, setEffect] = useState(false);

  const storedFirstAnswer = useMemo(() => {
    const stored = localStorage.getItem("first_answer_progress");
    if (!stored) return null;

    try {
      return JSON.parse(stored);
    } catch (error) {
      console.error("Invalid first_answer_progress JSON:", error);
      return null;
    }
  }, []);

  const storedSecondAnswer = useMemo(() => {
    const stored = localStorage.getItem("second_answer_progress");
    if (!stored) return null;

    try {
      return JSON.parse(stored);
    } catch (error) {
      console.error("Invalid second_answer_progress JSON:", error);
      return null;
    }
  }, []);

  const firstAnswer =
    storedFirstAnswer?.themeSlug === id ? storedFirstAnswer : null;

  const secondAnswer =
    storedSecondAnswer?.themeSlug === id ? storedSecondAnswer : null;

  useEffect(() => {
    if (user || googleUser) {
      localStorage.removeItem("first_answer");
      localStorage.removeItem("first_answer_progress");

      localStorage.removeItem("second_answer");
      localStorage.removeItem("second_answer_progress");
    }
  }, [firstAnswer, secondAnswer]);

  useEffect(() => {
    axios
      .get(`${apiUrl}/phase/byTheme/${id}`)
      .then((response) => {
        setPhase(response.data[0]);
      })
      .catch((err) => {});

    axios
      .get(`${apiUrl}/question/byPhaseAndTheme/Phase 1/${id}`)
      .then((response) => {
        setQuestion(response.data.sort((a, b) => a.id - b.id));
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (!user && !googleUser) return;

    const username = user?.username;
    const googleEmail = googleUser?.email;

    if (username) {
      axios
        .get(
          `${apiUrl}/user-question/byUserInfo/${username}/${id}/${phase && phase.title}`,
        )
        .then((response) => {
          const sorted = response.data.sort((a, b) => b.id - a.id);

          setPrecentCompletion(sorted[0]?.questionIndex);

          const sorted1 = sorted.filter((a) => a.questionIndex === 5);
          if (
            sorted1.length > 0 &&
            sorted1[0]?.phaseName === "Phase 1" &&
            sorted1[0]?.questionNumber === "Question 1_5"
          ) {
            setPhase1Complete(true);
            setPrecentCompletion(sorted1[0]?.questionIndex);
          }
        })
        .catch((err) => {});

      axios
        .get(`${apiUrl}/user-question/byUserAndTheme/${username}/${id}`, {
          withCredentials: true,
        })
        .then((response) => {
          const data = response.data;

          // store only user's responses for this phase
          const phase1 = data.filter(
            (uq) => uq.phaseName === "Phase 1" && username === uq.userUsername,
          );

          // now isolate each question
          setUserQuestion1(
            phase1.filter((uq) => uq.questionText === "Question 1_1"),
          );
          setUserQuestion2(
            phase1.filter((uq) => uq.questionText === "Question 1_2"),
          );
          setUserQuestion3(
            phase1.filter((uq) => uq.questionText === "Question 1_3"),
          );
          setUserQuestion4(
            phase1.filter((uq) => uq.questionText === "Question 1_4"),
          );
          setUserQuestion5(
            phase1.filter((uq) => uq.questionText === "Question 1_5"),
          );

          setChange((prevState) => !prevState);
        })
        .catch((err) => {});
    }

    if (googleEmail) {
      axios
        .get(
          `${apiUrl}/user-question/byGoogleUserInfo/${googleEmail}/${id}/${phase && phase.title}`,
        )
        .then((response) => {
          const sorted = response.data.sort((a, b) => b.id - a.id);

          setPrecentCompletion(sorted[0]?.questionIndex);

          const sorted1 = sorted.filter((a) => a.questionIndex === 5);
          if (
            sorted1.length > 0 &&
            sorted1[0]?.phaseName === "Phase 1" &&
            sorted1[0]?.questionNumber === "Question 1_5"
          ) {
            setPhase1Complete(true);
            setPrecentCompletion(sorted1[0]?.questionIndex);
          }
        })
        .catch((err) => {});

      axios
        .get(
          `${apiUrl}/user-question/byGoogleUserAndTheme/${encodeURIComponent(googleEmail)}/${id}`,
          {
            withCredentials: true,
          },
        )
        .then((response) => {
          const data = response.data;

          // store only user's responses for this phase
          const phase1 = data.filter(
            (uq) =>
              uq.phaseName === "Phase 1" && googleEmail === uq.googleEmail,
          );

          // now isolate each question
          setGoogleUserQuestion1(
            phase1.filter((uq) => uq.questionText === "Question 1_1"),
          );
          setGoogleUserQuestion2(
            phase1.filter((uq) => uq.questionText === "Question 1_2"),
          );
          setGoogleUserQuestion3(
            phase1.filter((uq) => uq.questionText === "Question 1_3"),
          );
          setGoogleUserQuestion4(
            phase1.filter((uq) => uq.questionText === "Question 1_4"),
          );
          setGoogleUserQuestion5(
            phase1.filter((uq) => uq.questionText === "Question 1_5"),
          );

          setChange((prevState) => !prevState);
        })
        .catch((err) => {});
    }
  }, [refreshTrigger, phase, precentCompletion]);

  function phaseClick1(id11) {
    setShowPhase1((prevState) => ({
      id1: id11,
      show: !prevState.show,
    }));
  }

  return (
    <>
      <button className="phaseSection p1Sec" onClick={() => phaseClick1(1)}>
        <div className="phaseTrack">
          {phase1Complete ? (
            <h3 className="phase-status-badge completed1">Completed</h3>
          ) : (
            <h3 className="phase-status-badge in-progress">In progress</h3>
          )}

          {showPhase1.show && showPhase1.id1 === 1 ? (
            <div
              className="arrowHead upward"
              role="button"
              tabIndex={0}
              style={{
                color: "rgba(242, 237, 229, 0.78)",
                fontFamily: "sans-serif",
              }}
              // onClick={(e) => {
              //   e.stopPropagation(); // VERY IMPORTANT
              //   // setEffect(true);
              // }}
            >
              ⌵
            </div>
          ) : (
            <div
              className="arrowHead downward"
              role="button"
              tabIndex={0}
              style={{
                color: "rgba(242, 237, 229, 0.78)",
                fontFamily: "sans-serif",
              }}
              // onClick={(e) => {
              //   e.stopPropagation(); // VERY IMPORTANT
              //   // setEffect(true);
              // }}
            >
              ⌵
            </div>
          )}
        </div>

        <div className="phaseArrowHeadParent phase-title-row">
          <h2 className="phase-title">
            {phase.title}: {phase.name}
          </h2>
        </div>
        <div
          // style={{ color: "gray" }}
          className="phaseSectionParagraph phase-desc"
        >
          {phase.description}
          <div className="progressLineParent">
            {(precentCompletion && precentCompletion === 1) || firstAnswer ? (
              <div className="progressLineChild" style={{ width: "20%" }}></div>
            ) : (precentCompletion && precentCompletion === 2) ||
              secondAnswer ? (
              <div className="progressLineChild" style={{ width: "40%" }}></div>
            ) : precentCompletion && precentCompletion === 3 ? (
              <div className="progressLineChild" style={{ width: "60%" }}></div>
            ) : precentCompletion && precentCompletion === 4 ? (
              <div className="progressLineChild" style={{ width: "80%" }}></div>
            ) : precentCompletion && precentCompletion === 5 ? (
              <div
                className="progressLineChild"
                style={{ width: "100%", backgroundColor: "green" }}
              ></div>
            ) : (
              <div className="progressLineChild" style={{ width: "0" }}></div>
            )}
          </div>
        </div>
        <p className="phase-progress-count">
          {precentCompletion
            ? precentCompletion + "/5"
            : "0/5" || (firstAnswer && secondAnswer)
              ? "2/5"
              : firstAnswer
                ? "1/5"
                : secondAnswer
                  ? "2/5"
                  : precentCompletion
                    ? precentCompletion + "/5"
                    : "0/5"}
        </p>
      </button>

      {showPhase1.show && showPhase1.id1 === 1 && (
        <>
          <div
            className={`${effect ? "phaseSecParentDisabled" : "phaseSecParent"}`}
          >
            {(userQuestion1[0] && userQuestion1[0]?.visited === true) ||
            (googleUserQuestion1[0] && googleUserQuestion1[0]?.visited) ||
            localStorage.getItem("first_answer") ? (
              <Link
                to={`/session/${id}/${phase.title}/${question[0].hashed}`}
                style={{ textDecoration: "none" }}
              >
                <button className="phaseSecChild p1q1 q1 session-label">
                  Session {question[0].questionNumber}
                  <span>
                    <img src="/check.png" alt="check" width={15} height={15} />
                  </span>
                </button>
                {/* <p>✅</p> */}
              </Link>
            ) : (
              <button className="phaseSecChild p1q1 q1 session-label" disabled>
                Session {question[0].questionNumber}
                <span className="locked-span">
                  <img src="/lock.png" alt="lock" width={10} height={10} />
                  LOCKED
                </span>
              </button>
            )}

            {(userQuestion2[0] && userQuestion2[0]?.visited === true) ||
            (googleUserQuestion2[0] && googleUserQuestion2[0]?.visited) ||
            localStorage.getItem("second_answer") ? (
              <Link
                to={`/session/${id}/${phase.title}/${question[1].hashed}`}
                style={{ textDecoration: "none" }}
              >
                <button className="phaseSecChild p1q1 q2">
                  Session {question[1].questionNumber}
                  <span>
                    <img src="/check.png" alt="check" width={15} height={15} />
                  </span>
                </button>
              </Link>
            ) : (
              <button className="phaseSecChild p1q1 q2" disabled>
                Session {question[1].questionNumber}
                <span className="locked-span">
                  <img src="/lock.png" alt="lock" width={10} height={10} />
                  LOCKED
                </span>
              </button>
            )}

            {(userQuestion3[0] && userQuestion3[0]?.visited === true) ||
            (googleUserQuestion3[0] && googleUserQuestion3[0]?.visited) ? (
              <Link
                to={`/session/${id}/${phase.title}/${question[2].hashed}`}
                style={{ textDecoration: "none" }}
              >
                <button className="phaseSecChild p1q1 q3">
                  Session {question[2].questionNumber}
                  <span>
                    <img src="/check.png" alt="check" width={15} height={15} />
                  </span>
                </button>
              </Link>
            ) : (
              <button className="phaseSecChild p1q1 q3" disabled>
                Session {question[2].questionNumber}
                <span className="locked-span">
                  <img src="/lock.png" alt="lock" width={10} height={10} />
                  LOCKED
                </span>
              </button>
            )}

            {(userQuestion4[0] && userQuestion4[0]?.visited === true) ||
            (googleUserQuestion4[0] && googleUserQuestion4[0]?.visited) ? (
              <Link
                to={`/session/${id}/${phase.title}/${question[3].hashed}`}
                style={{ textDecoration: "none" }}
              >
                <button className="phaseSecChild p1q1 q4">
                  Session {question[3].questionNumber}
                  <span>
                    <img src="/check.png" alt="check" width={15} height={15} />
                  </span>
                </button>
              </Link>
            ) : (
              <button className="phaseSecChild p1q1 q4" disabled>
                Session {question[3].questionNumber}
                <span className="locked-span">
                  <img src="/lock.png" alt="lock" width={10} height={10} />
                  LOCKED
                </span>
              </button>
            )}

            {(userQuestion5[0] && userQuestion5[0]?.visited === true) ||
            (googleUserQuestion5[0] && googleUserQuestion5[0]?.visited) ? (
              <Link
                to={`/session/${id}/${phase.title}/${question[4].hashed}`}
                style={{ textDecoration: "none" }}
              >
                <button className="phaseSecChild p1q1 q5">
                  Session {question[4].questionNumber}
                  <span>
                    <img src="/check.png" alt="check" width={15} height={15} />
                  </span>
                </button>
              </Link>
            ) : (
              <button className="phaseSecChild p1q1 q5" disabled>
                Session {question[4].questionNumber}
                <span className="locked-span">
                  <img src="/lock.png" alt="lock" width={10} height={10} />
                  LOCKED
                </span>
              </button>
            )}
          </div>
        </>
      )}
    </>
  );
}
